import { toAbsoluteUrl } from '@/utils';
import enAuth from './messages/en/auth.json';
import enMenu from './messages/en/menu.json';
import enOtp from './messages/en/otp.json';
import enResetPassword from './messages/en/reset-password.json';
import enVerifyEmail from './messages/en/verify-email.json';
import enAgents from './messages/en/agents.json';

import viAuth from './messages/vi/auth.json';
import viMenu from './messages/vi/menu.json';
import viOtp from './messages/vi/otp.json';
import viResetPassword from './messages/vi/reset-password.json';
import viVerifyEmail from './messages/vi/verify-email.json';
import viAgents from './messages/vi/agents.json';

const enMessages = {
  ...enAuth,
  ...enMenu,
  ...enOtp,
  ...enResetPassword,
  ...enVerifyEmail,
  ...enAgents,
};

const viMessages = {
  ...viAuth,
  ...viMenu,
  ...viOtp,
  ...viResetPassword,
  ...viVerifyEmail,
  ...viAgents,
};

const I18N_MESSAGES = {
  en: enMessages,
  vi: viMessages
};

const I18N_CONFIG_KEY = 'i18nConfig';

const I18N_LANGUAGES = [{
  label: 'Tiếng Việt',
  code: 'vi',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/vietnam.svg'),
  messages: I18N_MESSAGES.vi
},{
  label: 'English',
  code: 'en',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  messages: I18N_MESSAGES.en
}];

const I18N_DEFAULT_LANGUAGE = I18N_LANGUAGES[0];

export { I18N_CONFIG_KEY, I18N_DEFAULT_LANGUAGE, I18N_LANGUAGES, I18N_MESSAGES };